import axios from 'axios'
import {CADASTAR_DESCONTO_USUARIO_ROTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarDescontoUsuarioRota (descontoUsuario, idEmpresa) {
  const url = `${URL}/desconto-usuario-rota/empresa/${idEmpresa}/cadastrar`;

  return dispatch => axios.post(url, descontoUsuario, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTAR_DESCONTO_USUARIO_ROTA,
        payload: response
      })
  );
}
